import { render, staticRenderFns } from "./DisplayField.vue?vue&type=template&id=6355cb3f&scoped=true&"
import script from "./DisplayField.vue?vue&type=script&lang=ts&"
export * from "./DisplayField.vue?vue&type=script&lang=ts&"
import style0 from "./DisplayField.vue?vue&type=style&index=0&id=6355cb3f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6355cb3f",
  null
  
)

export default component.exports